export const Localization = (countries, currentCountry) => ({
  countries,
  currentCountry,
  open: false,
  value: "",
  form: null,
  url: "",

  init() {
    this.form = this.$el.querySelector("form");
    this.url = new URL(location);
  },

  submitForm(val) {
    this.value = val;
    this.form.submit();
  },
});
